/**
  * Computed
  */
import isSandbox from './computed/sandbox';
import debug from './computed/debug';

/**
  * Methods
  */
import RestDelete from './methods/rest_delete';
import RestList from './methods/rest_list';
import RestView from './methods/rest_view';
import vNodeFilter from './methods/vnode_filter';
import ie11 from './methods/ie11';

/**
  * Props
  */
import CompanyName from './props/company_name';
import CurrentView from  './props/current_view';
import Filename from './props/filename';
import Method from './props/method';
import Icon from './props/icon';
import IconFormat from './props/icon_format';
import IconSourcing from './props/icon_sourcing';
import Orientation from './props/orientation';
import Placeholder from './props/placeholder';
import Resource from './props/resource';
import ResourceId from './props/resource_id';
import RestUrl from './props/rest_url';
import Token from './props/token';
import Url from './props/url';
import Visible from './props/visible';

/**
  * Composite
  */
import Csrf from './csrf';
import Collapsable from './collapsable';
import Pointer from './pointer';
import Rest from './rest';
import Router from './router';
import Size from './size';
import Trans from './trans';

export default {
  /**
    * Computed
    */
  isSandbox, debug,
  /**
    * Methods
    */
  ie11, RestDelete, RestList, RestView, vNodeFilter,
  /**
    * Props
    */
  CompanyName, CurrentView, Filename, Icon, IconFormat, IconSourcing,
  Method, Orientation, Placeholder,
  Resource, ResourceId, RestUrl, Token, Url, Visible,
  /**
    * Composite
    */
  Csrf, Collapsable, Pointer, Rest, Router, Size, Trans
};
